import React, { useState, useRef, useEffect } from "react";
import { LayoutHome } from "../LayoutHome";
import { Card, Table, Button, Input, Space, notification } from "antd";
import { Checkbox, SelectPicker, Text, Tag, Tabs } from "rsuite";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { LockIcon, Save, Trash } from "lucide-react";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {
  getPerfiles,
  getDatosPerfil,
  getListaUsers,
  getCatUsers,
  getModulosSys,
  getModulosAsignados,
  savePermisoUser,
  deletePermiso,
  saveUser,
} from "../Services/CatalogosServices";
import { FaCheck } from "react-icons/fa";
import { partitionHTMLProps } from "rsuite/esm/internals/utils";


export const Usuarios = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [codNegocio] = useState(
    JSON.parse(localStorage.getItem("auth")).codNegocio,
  );
  const idUserSigned = JSON.parse(localStorage.getItem("auth")).idUser;
  const [dataTipoPerfil, setDataTipoPerfil] = useState([
    { label: "--SELECCIONA--", value: "" },
    { label: "Administrativo", value: "admin" },
    { label: "Médico", value: "medico" },
    { label: "Enfermero(a)", value: "enfermera" },
    { label: "Técnico", value: "tecnico" },
  ]);
  const [dataAccesos, setDataAccesos] = useState([
    { label: "--SELECCIONA--", value: "0" },
    { label: "Completo (Lectura/Escritura)", value: "LE" },
    { label: "Solo lectura", value: "L" },
  ]);
  const [dataModulos, setDataModulos] = useState([]);
  const [idModulo, setIdModulo] = useState(null);
  const [data, setData] = useState([]);
  const [idUser, setIdUser] = useState(0);
  const [idUserPermiso, setIdUserPermiso] = useState(0);
  const [tipoPerfil, setTipoPerfil] = useState("");
  const [dataPerfil, setDataPerfil] = useState([]);
  const [idPerfil, setIdPerfil] = useState("0");
  const [acceso, setAcceso] = useState(null);
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [fecVence, setFecVence] = useState("");
  const [activo, setActivo] = useState(1);
  const [msjErrMail, setErrMail] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(true);
  const [length, setLength] = useState(8);
  const [coincide, setCoincide] = useState(true);
  const [includeNumbers, setIncludeNumbers] = useState(true);
  const [dataCatUsers, setDataCatUsers] = useState([]);
  const [dataPermisos, setDataPermisos] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check

  const initialized = useRef(false);
  const [api, contextHolder] = notification.useNotification();

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Nombre(s)",
      dataIndex: "nombre",
      width: "20%",
      key: "nombre",
      sorter: (a, b) => a.nombre.length - b.nombre.length,
      ...getColumnSearchProps("nombre"),
    },
    {
      title: "Usuario",
      dataIndex: "nomUsr",
      width: "15%",
      key: "nomUsr",
      sorter: (a, b) => a.user.length - b.user.length,
      ...getColumnSearchProps("nombre"),
    },
    {
      title: "Es Médico",
      dataIndex: "idMedico",
      width: "10%",
      key: "idMedico",
      align: "center",
      render: (text) =>
        text > 0 ? (
          <Tag color="blue">
            <FaCheck></FaCheck>
          </Tag>
        ) : (
          ""
        ),
    },
    {
      title: "Es Enfermera(o)",
      dataIndex: "idEnf",
      width: "10%",
      key: "idEnf",
      align: "center",
      render: (text) =>
        text > 0 ? (
          <Tag color="blue">
            <FaCheck></FaCheck>
          </Tag>
        ) : (
          ""
        ),
    },
    {
      title: "Es Técncio",
      dataIndex: "idTec",
      width: "10%",
      key: "idTec",
      align: "center",
      render: (text) =>
        text > 0 ? (
          <Tag color="blue">
            <FaCheck></FaCheck>
          </Tag>
        ) : (
          ""
        ),
    },
    {
      title: "Estatus",
      dataIndex: "estatus",
      width: "5%",
      key: "estatus",
      align: "center",
      render: (text) =>
        text === 1 ? (
          <Tag color="green">Activo</Tag>
        ) : (
          <Tag color="red">Inactivo</Tag>
        ),
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "5%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<EditOutlined />}
          color="primary"
          variant="outlined"
          onClick={() =>
            edit({
              idUser: record.idUser,
              nombre: record.nombre,
              correo: record.correo,
              esMedico: record.idMedico,
              esEnf: record.idEnf,
              esTec: record.idTec,
              perfil: record.perfil,
              user: record.nomUsr,
              password: record.pwdUsr,
              activo: record.estatus,
            })
          }
        ></Button>
      ),
    },
  ];

  const columnsPermisos = [
    {
      title: "Módulo",
      dataIndex: "menu",
      width: "20%",
      key: "menu",
      sorter: (a, b) => a.menu.length - b.menu.length,
      ...getColumnSearchProps("menu"),
    },
    {
      title: "Acceso",
      dataIndex: "descripAcceso",
      width: "30%",
      key: "descripAcceso",
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "10%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<Trash size={16} color="red"></Trash>}
          onClick={() => {
            eliminaPermiso({
              idSubmenu: record.idSubmenu,
            });
          }}
        ></Button>
      ),
    },
  ];

  const edit = (props) => {
    var _idPerfil = 0;

    if(props.esEnf > 0) { _idPerfil = props.esEnf; }
    if(props.esMedico > 0) { _idPerfil = props.esMedico; }
    if(props.esTec > 0) { _idPerfil = props.esTec; }

    setTipoPerfil(props.perfil);
    loadPerfiles(props.perfil).then(() => {
      setIdPerfil(String(_idPerfil));
      setIdUser(props.idUser);
      setNombre(props.nombre);
      setCorreo(props.correo);
      setUser(props.user);
      setPassword(props.password);
      setActivo(props.activo);
    });
  };

  const clickCreaUser = (e) => {
    if (e.target.checked) {
      generateUsername();
    } else {
      setUser("");
    }
  };

  const generateUsername = () => {
    // 1. Minúsculas, eliminar espacios extra
    // let base = nombre.toLowerCase().trim().replace(/\s+/g, "");
    let base = nombre.toLowerCase().trim();
    const newBase = nombre.split(" ");
    const letraInicial = newBase[0].substring(0, 1).toLowerCase();
    const aPaterno = newBase[1].toLowerCase();
    const aMaterno = newBase[2].substring(0, 2).toLowerCase();
    const userName = `${letraInicial}.${aPaterno}${aMaterno}`;

    // 2. Añadir números aleatorios para unicidad
    const randomNumber = Math.floor(Math.random() * 100);
    // 3. Resultado: nombre123
    setUser(`${userName}`);
  };

  const generatePassword = () => {
    let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    if (includeNumbers) charset += "0123456789";

    let generatedPassword = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      generatedPassword += charset[randomIndex];
    }
    setPassword(generatedPassword);
  };

  const loadPerfiles = async (perfil) => {
    if (perfil === null) {
      setNombre("");
      setCorreo("");
    }
    setTipoPerfil(perfil);
    setDataPerfil([{ label: "--SELECCIONA--", value: "" }]);
    await getPerfiles(idNegocio, perfil)
      .then((res) => {
        setDataPerfil((prev) => [...prev, ...res]);
        setIdPerfil("0");
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadPermisos = async (idUser) => {
    setIdUserPermiso(idUser);
    if (idUser === null) {
      setDataPermisos([]);
      return;
    }
    await getModulosAsignados(idNegocio, idUser).then((res) => {
      setDataPermisos(res);
    });
  };

  const eliminaPermiso = async (props) => {
    console.log(props);
    const data = {
      id: idNegocio,
      idSubmenu: props.idSubmenu,
      idUser: idUserPermiso,
      acceso: "-",
    };

    await deletePermiso(data)
      .then((res) => {
        if (res.data > 0) {
          loadPermisos(idUserPermiso);
        } else {
          errorNotificaction(
            "Error",
            "Ocurrio un error al eliminar el permiso.",
          );
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const savePermiso = async () => {
    const data = {
      id: idNegocio,
      idSubmenu: idModulo,
      idUser: idUserPermiso,
      acceso: acceso,
    };

    await savePermisoUser(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Permisos",
            "Se ha registrado el permiso de forma correcta.",
          );
          setIdModulo(null);
          setAcceso(null);
          loadPermisos(idUserPermiso);
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const loadCatUsuarios = async () => {
    await getCatUsers(idNegocio, idUserSigned)
      .then(async (res) => {
        setDataCatUsers(res);
        await getModulosSys(idNegocio).then((res) => {
          setDataModulos(res);
        });
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const setDatosPerfil = async (ID) => {
    setIdPerfil(ID);
    await getDatosPerfil(idNegocio, tipoPerfil, ID)
      .then((res) => {
        setNombre(res.nombre);
        setCorreo(res.correo);
      })
      .catch((error) => {
        errorNotificaction(error.messgae, error.name);
      });
  };

  const validateEmail = (email) => {
    setCorreo(email);
    if (!email) {
      setErrMail("");
      return;
    }
    // A common regex pattern for email format validation
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) {
      setErrMail("*Formato incorrecto*");
    } else {
      setErrMail("");
    }
  };

  const loadUsers = async () => {
    await getListaUsers(idNegocio, idUserSigned)
      .then((res) => {
        setData(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const save = async () => {
    const data = {
      codNegocio: codNegocio,
      IdConsultorio: idNegocio,
      IdUser: idUser,
      IdMedico: tipoPerfil === "medico" ? idPerfil : 0,
      IdEnfermera: tipoPerfil === "enfermera" ? idPerfil : 0,
      IdTecnico: tipoPerfil === "tecnico" ? idPerfil : 0,
      Correo: correo,
      NomCompleto: nombre,
      Perfil: tipoPerfil,
      NomUser: user,
      PwdUser: password,
      FecVence: null,
      Estatus: activo,
    };

    await saveUser(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Usuario",
            "Se ha registrado el usuario, de forma correcta.",
          );
          setTimeout(() => {
            window.location.reload();
          }, 600);
        } else {
          errorNotificaction("Error", "Ocurrio un error al guardar");
        }
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };

    if (!initialized.current) {
      initialized.current = true;
      loadUsers().then((nxt) => {
        loadCatUsuarios();
      });
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []);

  return (
    <>
      <title>Usuarios - NefroSys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Usuarios" },
        ]}
        selectedKey={"1.8"}
      >
        {contextHolder}
        <Tabs defaultActiveKey="1">
          <Tabs.Tab eventKey="1" title="Catálogo de Usuarios">
            <Card title="Usuario del Sistema">
              <div className="row mb-3">
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Text>Perfil</Text>
                  <SelectPicker
                    data={dataTipoPerfil}
                    value={tipoPerfil}
                    onChange={(e) => loadPerfiles(e)}
                    block
                    searchable={false}
                    placeholder="--Selecicona--"
                  />
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Text>Perfil de Trabajo</Text>
                  <SelectPicker
                    data={dataPerfil}
                    block
                    value={idPerfil}
                    disabled={
                      tipoPerfil === "admin" ||
                      tipoPerfil === "" ||
                      tipoPerfil === null
                        ? true
                        : false
                    }
                    placeholder="--SELECCIONA--"
                    onChange={(e) => setDatosPerfil(e)}
                    searchable={false}
                  />
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Text>Nombre completo</Text>
                  <Input
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <Text>Correo</Text>
                  <Input
                    value={correo}
                    onChange={(e) => validateEmail(e.target.value)}
                  />
                  <Text size={"xs"} color={"red"} style={{ paddingTop: "5px" }}>
                    {msjErrMail}
                  </Text>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-1 col-md-1 col-sm-1">
                  <Checkbox onClick={(e) => clickCreaUser(e)}>
                    Crear usuario
                  </Checkbox>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Text>Usuario</Text>
                  <Input
                    maxLength={50}
                    value={user}
                    onChange={(e) => setUser(e.target.value)}
                  />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Text>Contraseña</Text>
                  <Input.Password
                    placeholder="Escribe la contraseña..."
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    maxLength={20}
                    visibilityToggle={{
                      visible: passwordVisible,
                      onVisibleChange: setPasswordVisible,
                    }}
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Text>Confirma la contraseña</Text>
                  <Input.Password
                    placeholder="Escribe la contraseña..."
                    maxLength={20}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    visibilityToggle={{
                      visible: passwordVisible,
                      onVisibleChange: setPasswordVisible,
                    }}
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                  <span style={{ color: "red" }}>
                    {coincide ? "" : "¡No coincide la contraseña!"}
                  </span>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <br></br>
                  <Button
                    icon={<LockIcon size={20}></LockIcon>}
                    type="primary"
                    onClick={generatePassword}
                    disabled={user.length > 0 ? false : true}
                    block
                  >
                    Generar contraseña
                  </Button>
                </div>
                <div className="text-end col-lg-2 col-md-2 col-sm-2">
                  <br></br>
                  <Button
                    type="primary"
                    icon={<Save size={20}></Save>}
                    onClick={save}
                    block
                  >
                    Guardar
                  </Button>
                </div>
              </div>
            </Card>
            <br></br>
            <Card title="Lista de usuarios">
              <div style={{ overflowX: isMobile ? "scroll" : "none" }}>
                <div className="row">
                  <div className="col">
                    <Table
                      key={`tblUsuarios`}
                      bordered
                      size="small"
                      rowKey={(record) => record.idUser}
                      columns={columns}
                      dataSource={data}
                      pagination={{ pageSize: 5 }}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </Tabs.Tab>
          <Tabs.Tab eventKey="2" title="Permisos">
            <Card title="Asignación de permisos">
              <div className="row mb-3">
                <div className="col-lg-4 col-md-4 col-sm-3">
                  <Text>Usuario</Text>
                  <SelectPicker
                    block
                    data={dataCatUsers}
                    onChange={(e) => loadPermisos(e)}
                    searchable={false}
                    placeholder="--SELECCIONA--"
                  />
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Text>Módulo</Text>
                  <SelectPicker
                    data={dataModulos}
                    block
                    value={idModulo}
                    placeholder="--SELECCIONA--"
                    onChange={(e) => setIdModulo(e)}
                    disabled={idUserPermiso === 0 ? true : false}
                  />
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Text>Tipo de acceso</Text>
                  <SelectPicker
                    data={dataAccesos}
                    block
                    placeholder="--SELECCIONA--"
                    searchable={false}
                    value={acceso}
                    onChange={(e) => setAcceso(e)}
                    disabled={
                      idUserPermiso === 0 && idModulo === null ? true : false
                    }
                  />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <br></br>
                  <Button
                    icon={<Save size={20}></Save>}
                    disabled={
                      acceso !== null && acceso !=="0" && idModulo !== null ? false : true
                    }
                    onClick={savePermiso}
                    type="primary"
                  >
                    Guardar
                  </Button>
                </div>
              </div>
            </Card>
            <br></br>
            <Card title="Módulos asignados">
              <div style={{ overflowX: isMobile ? 'scroll' : 'none' }}>
                <div className="row">
                  <div className="col">
                    <Table
                      key={`tblUsuariosPermisos`}
                      bordered
                      size="small"
                      rowKey={(record) => record.idSubmenu}
                      columns={columnsPermisos}
                      dataSource={dataPermisos}
                      pagination={{ pageSize: 5 }}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </Tabs.Tab>
        </Tabs>
      </LayoutHome>
    </>
  );
};
